// Single source of truth for firmware-upgrade status vocabularies +
// chip color mapping. Mirrors the backend (see
// pliny/services/firmware_upgrades.py — compute_log_status — and
// pliny/models/units.py FirmwareUpgradeBatch.STATUS_CHOICES). Adding a
// new status only requires a row here.

// Per-unit row status — derived backend-side by compute_log_status.
export const UNIT_STATUS = Object.freeze({
  QUEUED: 'queued',
  UPGRADING: 'upgrading',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
});

// Whole-batch status — backed by FirmwareUpgradeBatch.STATUS_CHOICES.
export const BATCH_STATUS = Object.freeze({
  PENDING: 'pending',
  RUNNING: 'running',
  COMPLETED: 'completed',
  PARTIAL: 'partial',
  FAILED: 'failed',
  CANCELLING: 'cancelling',
  CANCELLED: 'cancelled',
});

// Status set the cancel button is disabled for — anything not actively
// in flight. Mirrors FirmwareUpgradeBatch.TERMINAL_STATUSES + the
// CANCELLING transient (user already hit cancel, don't let them
// double-click into a confused state).
export const BATCH_CANCEL_DISABLED = Object.freeze(
  new Set([
    BATCH_STATUS.COMPLETED,
    BATCH_STATUS.PARTIAL,
    BATCH_STATUS.FAILED,
    BATCH_STATUS.CANCELLED,
    BATCH_STATUS.CANCELLING,
  ]),
);

// MUI Chip color per status. Used by both the batch header chip and
// the per-unit chip — same label same color.
export const STATUS_COLOR = Object.freeze({
  [BATCH_STATUS.PENDING]: 'default',
  [BATCH_STATUS.RUNNING]: 'info',
  [BATCH_STATUS.PARTIAL]: 'warning',
  [BATCH_STATUS.COMPLETED]: 'success',
  [BATCH_STATUS.FAILED]: 'error',
  [BATCH_STATUS.CANCELLING]: 'warning',
  [BATCH_STATUS.CANCELLED]: 'default',
  [UNIT_STATUS.QUEUED]: 'default',
  [UNIT_STATUS.UPGRADING]: 'info',
  [UNIT_STATUS.SUCCEEDED]: 'success',
  [UNIT_STATUS.FAILED]: 'error',
});
